<template>
  <div
    id="side-menu"
    class="side-menu__wrap pb-12"
    :class="classes"
  >
    <div
      class="side-menu !pt-2 lg:!pt-3"
      :class="{ 'side-menu-collapsed': collapsed, 'side-menu-collapsible': collapsible, 'side-menu-overflow': overflow }"
    >
      <div
        v-if="collapsible"
        class="sidemenu-collapse"
        @click="collapsed = !collapsed"
      >
        <button class="btn btn-link btn-white">
          <fa
            class="text-white"
            :icon="collapsed ? 'chevron-down' : 'chevron-up'"
          />
        </button>
      </div>
      <div
        v-show="activeSubmenu"
        class="submenu-overlay"
        @click="setSubmenu(null)"
      />
      <div class="w-full lg:pb-1.5">
        <nuxt-link
          v-for="(toplink, i) in tripTypesSidebar.toplinks"
          :key="i"
          :to="toplink.url"
          class="side-menu-title first-title text-white hover:text-white text-sm !mb-2 flex items-center w-full"
          @click="menuStore.closeSideMenuActive()"
        >
          <span
            class="side-menu-icon mr-1 max-lg:-ml-2"
          >
            <fa
              class="min-h-5 min-w-5 h-5 w-5"
              :icon="toplink.icon"
            />
          </span>
          <span
            class="inline text-base"
          >
            {{ toplink.name }}
          </span>
        </nuxt-link>
      </div>
      <hr class="max-lg:hidden" />
      <template v-if="sideMenuActive">
        <div class="md:mt-2 -ml-2 py-3">
          <LazyAlgoliaSearchBar
            :autofocus="false"
            :header="true"
            input-class="!rounded-none !h-14"
            @search="menuStore.closeSideMenuActive()"
            @hide-search-bar="menuStore.closeSideMenuActive()"
          />
        </div>
      </template>
      <ul
        v-for="(triptypesGroup, index) in tripTypesSidebar.content"
        :key="index"
        class="side-menu-section"
        :class="{ 'with-border': Object.keys(triptypesGroup.categories).length === 1 }"
      >
        <li :class="activeSubmenu === triptypesGroup.name ? 'active' : 'non'">
          <span
            v-if="hasSubCategories(triptypesGroup)"
            class="side-menu-title category-title text-base"
          >
            {{ triptypesGroup.name }}
          </span>
          <template v-else>
            <a
              :href="triptypesGroup.categories[Object.keys(triptypesGroup.categories)[0]].category_links[0].url"
              :class="[
                'side-menu-title category-title hover:text-white text-base',
                activeSubmenu === triptypesGroup.name ? 'active-nav-item' : ''
              ]"
              @click.prevent="setSubmenu(triptypesGroup.name)"
            >
              {{ triptypesGroup.name }}
            </a>
            <LazySubmenu
              v-if="activeSubmenu === triptypesGroup.name"
              class="!py-0 side-menu-subcategories !bg-transparent"
              :title="triptypesGroup.name"
              :title-translation="triptypesGroup?.name_translationkey"
              :trips="triptypesGroup.categories[Object.keys(triptypesGroup.categories)[0]].trips"
              :category-links="triptypesGroup.categories[Object.keys(triptypesGroup.categories)[0]].category_links"
              @close="setSubmenu(null)"
            />
          </template>
        </li>
        <li v-if="hasSubCategories(triptypesGroup)">
          <ul class="side-menu-subcategories font-secondary text-base font-normal">
            <li
              v-for="(category, idx) in triptypesGroup.categories"
              :key="idx"
              :class="activeSubmenu === category.name ? 'active' : 'non'"
              class="hover:bg-blue-100"
            >
              <a
                :href="category.category_links[0].url"
                :class="activeSubmenu === category.name ? 'font-black ' : '' "
                @click.prevent="setSubmenu(category.name)"
              >
                {{ category.name }}
              </a>
              <LazySubmenu
                v-if="activeSubmenu === category.name"
                :title="category.name"
                :trips="category.trips"
                :category-links="category.category_links"
                @close="setSubmenu(null)"
              />
            </li>
          </ul>
        </li>
      </ul>
      <div class="hamburgerMenuWrapper pt-4 -mb-4">
        <ul
          v-for="(navItem, index) in topNavbar"
          :key="index"
          class="side-menu-section"
          :class="{ 'mb-4': navItem.mobileview && sideMenuActive }"
        >
          <li
            v-if="navItem.mobileview && sideMenuActive"
            :class="activeHamburgerMenu === navItem.label ? 'active' : 'non'"
            @click="activeHamburgerMenu = navItem.label"
          >
            <div class="flex justify-between pl-6 font-semibold font-primary pb-1 relative">
              <a
                v-if="navItem.submenu && navItem.submenu.length"
                class="hover:text-white/75"
              >
                {{ navItem.label }}
              </a>
              <nuxt-link
                v-else
                :to="navItem.link"
                class="hover:text-white/75"
                @click="menuStore.closeSideMenuActive()"
              >
                {{ navItem.label }}
              </nuxt-link>
              <button
                v-if="activeHamburgerMenu === navItem.label"
                class="btn btn-link submenu-close text-white py-0"
                @click.stop="activeHamburgerMenu = null"
              >
                <fa
                  icon="times"
                  width="18"
                />
              </button>
            </div>
            <ul
              v-if="navItem.submenu && activeHamburgerMenu === navItem.label"
              class="bg-white w-full py-4"
            >
              <li
                v-for="(item, i) in navItem.submenu"
                :key="i"
                class="py-1 font-inter"
              >
                <div
                  v-if="item.label === 'linebreak'"
                  class="dropdown-divider"
                />
                <a
                  v-else-if="item.absoluteLink"
                  class="dropdown-item !px-9 text-black font-primary text-base hover:bg-blue-100 !font-semibold"
                  :href="item.link"
                  target="_blank"
                >
                  {{ item.label }}
                </a>
                <nuxt-link
                  v-else
                  class="!px-9 text-black font-primary text-base hover:bg-blue-100 font-semibold"
                  :to="item.link"
                  @click="menuStore.closeSideMenuActive()"
                >
                  {{ item.label }}
                </nuxt-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'

export default defineNuxtComponent({
  setup () {
    const menuStore = useMenuStore()

    return {
      menuStore,
    }
  },

  name: 'Sidebar',

  props: {
    collapsible: {
      type: Boolean,
      default: false,
    },

    preventLayoutingClasses: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      activeSubmenu: null,
      activeHamburgerMenu: null,
      collapsed: this.collapsible,
      overflow: false,
      timer: null,
    }
  },

  computed: {
    ...mapState(useRootStore, {
      topNavbar: 'topNavbar',
      tripTypesSidebar: 'tripTypesSidebar',
    }),

    ...mapState(useMenuStore, {
      sideMenuActive: 'sideMenuActive',
    }),

    classes () {
      let c = []
      if (!this.preventLayoutingClasses) {
        c = ['hidden', 'lg:block', 'float-left', 'px-0']
      }
      if (this.sideMenuActive) {
        c.push('mobile-side-menu__active')
      }
      return c
    },
  },

  watch: {
    collapsible (v) {
      if (v) {
        this.collapsed = true
      } else {
        this.collapsed = false
      }
    },

    collapsed (v) {
      if (v) {
        this.overflow = false
        this.setSubmenu(null)
      } else {
        this.timer = window.setTimeout(() => {
          this.overflow = true
        }, 1000)
      }
    },
  },

  mounted () {
    window.addEventListener('resize', this.resizeListener)
  },

  beforeUnmount () {
    clearTimeout(this.timer)
    window.removeEventListener('resize', this.resizeListener)
  },

  methods: {
    hasSubCategories (group) {
      return Object.keys(group.categories).length > 1
    },

    resizeListener () {
      if (window.innerWidth > 768) {
        this.menuStore.closeSideMenuActive()
      }
    },

    setSubmenu (submenu) {
      this.activeSubmenu = submenu
    },
  },
})
</script>
